<template>
    <div
        ref="playbackRate"
        class="sbs-video-player-playback-rate"></div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';

export default {
    name: 'SbsVideoPlayerPlaybackRate',
    inject: {
        videoPlayerComponent: { default: null },
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
    },
    mounted() {
        const PlaybackRateMenuButton = videojs.getComponent('playbackRateMenuButton');
        const playbackRateMenuButtonComponent = new PlaybackRateMenuButton(this.player, {
            title: 'Скорость',
        });
        const playbackRate = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.playbackRate,
        });

        playbackRate.addChild(playbackRateMenuButtonComponent);
    },
};
</script>

<style lang="scss">
// stylelint-disable selector-max-compound-selectors

.sbs-video-player-playback-rate {
    .vjs-playback-rate.vjs-menu-button-popup:hover .vjs-playback-rate-value {
        color: var(--video-player-theme);
        transition: color $trs;
    }

    .vjs-playback-rate .vjs-menu {
        left: -20px;
        width: 164px;
    }

    .vjs-playback-rate .vjs-playback-rate-value {
        top: 4px;
        font-size: 16px;
    }

    .vjs-playback-rate .vjs-menu-title {
        margin: 0 0 6px;
        padding-left: 10px;
        color: $white;
        text-align: left;
        opacity: 0.6;

        @include typo-subsecondary-demi;
    }

    .vjs-playback-rate.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
        bottom: 17px;
        max-height: none;
        padding: 20px 10px;
        font-family: "Fedra Sans Pro", sans-serif;
        background-color: $black;
        border-radius: $rounded-10;
    }

    .vjs-menu .vjs-menu-item {
        padding: 2px 10px;
        text-align: left;

        @include typo-secondary-book;

        &:hover {
            background-color: $gray-deep;
            border-radius: $rounded-5;
        }

        &.vjs-selected {
            color: $white;
            background-color: $transparent;

            @include typo-secondary-medium;

            &::after {
                position: absolute;
                right: 10px;
                width: 17px;
                height: 12px;
                margin-top: 3px;
                background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='17' height='12' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0.292893 6.70708C-0.0976311 6.31655 -0.097631 5.68339 0.292893 5.29286C0.683417 4.90234 1.31658 4.90234 1.70711 5.29286L6.65685 10.2426C7.04738 10.6331 7.04738 11.2663 6.65685 11.6568C6.26633 12.0473 5.63316 12.0473 5.24264 11.6568L0.292893 6.70708Z' fill='white'/%3e%3cpath d='M15.1785 0.292893C15.569 -0.0976311 16.2022 -0.0976311 16.5927 0.292893C16.9832 0.683417 16.9832 1.31658 16.5927 1.70711L6.6932 11.6066C6.30268 11.9971 5.66951 11.9971 5.27899 11.6066C4.88847 11.2161 4.88847 10.5829 5.27899 10.1924L15.1785 0.292893Z' fill='white'/%3e%3c/svg%3e ");
                content: "";
            }
        }
    }
}
</style>
